import React from "react";

// packages
import classNames from "classnames";
import { useTranslation } from "react-i18next";

// component
import Pill from "../../../common/Pill";

// styles
import styles from "./WaitingBuyerJoin.module.scss";

const WaitingBuyerJoin = () => {
  const { t } = useTranslation();
  return (
    <Pill
      styleName={"usersJoin"}
      Lefticon={<img src={"../../../assets/images/svg/users.svg"} />}>
      <p className={classNames(styles.text, "p2")}>
        {t("lbl_waiting_user_join")}
      </p>
    </Pill>
  );
};

export default WaitingBuyerJoin;
